import { Table } from "antd";
import { useContext, useState } from "react";
import CreateCompany from "./components/CreateCompany";
import UpdateCompany from "./components/UpdateCompany";
import DeleteCompany from "./components/DeleteCompany";
import { useQuery } from "@tanstack/react-query";
import Something from "../../components/shared/Something";
import { handleFetchCompanies } from "../../api/companies";
import placeholder from "../../assets/images/placeholder.jpg";
import { DeleteOutlined, EditFilled } from "@ant-design/icons";
import Error from "../../components/shared/Error";
import { AuthContext } from "../../contexts/AuthContext";

export default function Companies() {
  const { user } = useContext(AuthContext);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const adminAccess = [9];

  const {
    data: companies,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["companies"],
    queryFn: handleFetchCompanies,
  });

  const columns: any = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "LOGO",
      width: 50,
      render: (record: any) => (
        <div className="">
          <img
            src={record?.logo || placeholder}
            alt=""
            width={60}
            height={60}
          />
        </div>
      ),
    },
    {
      title: "COMPANY NO.",
      width: 80,
      align: "center",
      render: (record: any) => (
        <span className="text-gray-700 uppercase">{record?.code || "-"}</span>
      ),
    },
    {
      title: "COMPANY NAME",
      width: 380,
      render: (record: any) => (
        <span className="text-gray-700 capitalize">{record?.name || "-"}</span>
      ),
    },
    {
      title: "ACTION",
      width: 180,
      render: (record: any) => (
        <div className="flex items-center">
          <button
            onClick={() => {
              setSelected(record);
              setUpdateModal(true);
            }}
            className="border py-1 px-2 mx-1 flex items-center bg-yellow-50 text-yellow-800 shadow-sm hover:bg-yellow-100"
          >
            <EditFilled />
          </button>

          <button
            onClick={() => {
              setSelected(record);
              setDeleteModal(true);
            }}
            className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm hover:bg-red-100"
          >
            <DeleteOutlined />
          </button>
        </div>
      ),
    },
  ];

  if (!adminAccess.includes(user?.accessLevel)) {
    return <Error error="You are not authorized to access this page" />;
  }

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex justify-between border p-2">
          <div className="">
            <div className="font-bold text-lg">Legal Entities</div>
            <div className="text-gray-600">Manage Autoline Companies</div>
          </div>
          <div className="">
            <button
              onClick={() => setCreateModal(true)}
              className="flex mx-2 justify-center items-center border px-4 h-8 bg-karimjee hover:bg-karimjee-dark text-white shadow-sm"
            >
              + New
            </button>
          </div>
        </div>

        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border p-2">
            <Table
              columns={columns}
              dataSource={companies}
              size="small"
              bordered
              pagination={{ pageSize: 20 }}
              scroll={{ y: 525 }}
              loading={isLoading}
              rowKey="_id"
            />
          </div>
        )}
      </div>

      <CreateCompany
        isVisible={createModal}
        setVisible={setCreateModal}
        refetch={refetch}
      />

      <UpdateCompany
        isVisible={updateModal}
        setVisible={setUpdateModal}
        selected={selected}
      />

      <DeleteCompany
        isVisible={deleteModal}
        setVisible={setDeleteModal}
        selected={selected}
      />
    </div>
  );
}
